import React, { useMemo, FC } from 'react';

import { IPrizeMerchant } from '../../../../types';
import Aragosta from '../../templates/Aragosta';
import addHardcodedLinks from './services/addHardcodedLinks';

import styles from './index.module.sass';

interface RaosProps {
  merchant: IPrizeMerchant;
}

const Raos: FC<RaosProps> = ({ merchant }) => {
  const links = useMemo(() => addHardcodedLinks( merchant.webLinks ), [ merchant.webLinks ]);

  return <Aragosta className={{ container: styles.container }} links={links} merchant={merchant} />;
};

export default Raos;
